import { Wind, Sofa, Repeat, Gem, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";
import { useApp } from "../context/AppContext";
import { WHY_CARE } from "../config/defaults";

const ICONS = { wind: Wind, sofa: Sofa, repeat: Repeat, gem: Gem };

export default function WhyCarCare() {
  const { openBooking } = useApp();
  return (
    <section id="why-care" className="light-section relative py-20 lg:py-28" data-testid="why-care-section">
      <div className="dot-grid-light pointer-events-none absolute inset-0" />
      <div className="container-x relative">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Reveal><span className="eyebrow eyebrow-dark">Why Car Care Matters</span></Reveal>
            <Reveal delay={0.06}>
              <h2 className="mt-4 max-w-2xl text-3xl font-bold leading-[1.12] tracking-tight text-nighttext sm:text-4xl lg:text-5xl">
                Your Car Needs More Than a Wash.
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-[#5c5470] sm:text-lg">
                Indian roads, dust and daily use take a quiet toll on every vehicle. Regular, professional care is what keeps a car looking and feeling new.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <button onClick={() => openBooking()} className="btn btn-primary px-7 py-4 text-[15px]" data-testid="why-care-cta">
              Book Your Car Care <ArrowRight size={16} />
            </button>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_CARE.map((c, i) => {
            const Icon = ICONS[c.icon] || Gem;
            return (
              <Reveal key={c.title} delay={i * 0.07}>
                <div className="card-light flex h-full flex-col gap-4 rounded-3xl p-6" data-testid={`why-care-card-${i}`}>
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-carza-dim text-carza">
                    <Icon size={20} />
                  </span>
                  <div>
                    <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3d3455]">{c.title}</h3>
                    <p className="mt-2.5 text-[15px] leading-relaxed text-[#2a2438]">{c.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2} className="mt-12">
          <p className="text-center font-display text-xl font-semibold text-nighttext sm:text-2xl" data-testid="why-care-urgency">
            Don't wait until your car looks neglected.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
